'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isUserVerified = undefined;

var _sagaTools = require('@classpass/saga-tools');

var isUserVerified = exports.isUserVerified = (0, _sagaTools.makeEntityScaffold)('SAGA.API.IS_USER_VERIFIED', function (client, options) {
  return client.phoneVerification.isUserVerified(options).catch(function (err) {
    if (err.httpStatus === 404) {
      return false;
    }
    throw err;
  });
});